import Attachment from "./Attachment";
import HeaderContent from "./components/HeaderContent";
import InfoDetailsContent from "./components/InfoDetailsContent";
import Modal from "./components/Modal";
import OrderedList from "./components/OrderedList";

const OrderDetailsComponents = {
  Attachment,
  HeaderContent,
  InfoDetailsContent,
  Modal,
  OrderedList,
};

export default OrderDetailsComponents;
